
module.exports = () => {};
